<ng-container *ngIf="styleReady">
  <!-- Your real app content -->
  <router-outlet></router-outlet>
</ng-container>
